
import React from "react";
import { Badge } from "@/components/ui/badge";
import { Heart } from "lucide-react";

type SaveCountDisplayProps = {
  saveCount: number;
  isCreator: boolean;
  showInline?: boolean;
};

export const SaveCountDisplay: React.FC<SaveCountDisplayProps> = ({ 
  saveCount, 
  isCreator, 
  showInline = false 
}) => {
  if (!isCreator || saveCount === 0) return null;

  if (showInline) {
    return (
      <Badge variant="outline" className="flex items-center gap-1">
        <Heart className="h-3 w-3" />
        {saveCount} {saveCount === 1 ? 'save' : 'saves'}
      </Badge>
    );
  }

  return (
    <div className="flex items-center gap-2 text-sm text-muted-foreground">
      <Heart className="h-4 w-4" />
      <span>
        Saved by {saveCount} {saveCount === 1 ? 'user' : 'users'}
      </span>
    </div>
  );
};
